import FeedbackPage from "../../components/Feedback";

const Feedback = () => {
  return (
    <FeedbackPage />
  );
};

export default Feedback;
